module.exports = __webpack_public_path__ + "static/media/bathroom-green.0b725cb2.jpg";